/* eslint-disable no-param-reassign */

import _has from 'lodash/has';
import _set from 'lodash/set';
import _get from 'lodash/get';
import * as sdkToUI from '../../adapter/style-adapters/sdk-ui';
import * as uiToSdk from '../../adapter/style-adapters/ui-sdk';
import ChangesetHelper from '@src/slide/domain/ui-model/changesetManager/changesetHelper';
import { enumerateGroup } from '@src/slide/domain/ui-model/element-modeles/property/group-operation/enumerate';

export default class StyleConvert {
    /**
     *
     * @param sdkData       需要转换的UI数据，UIModel的子集
     * @param uiData        转换到的目标数据
     */
    public static convertDataSdkToUi(sdkData, uiData, csData) {
        // background
        if (uiData.type === 'Slide') {
            StyleConvert.convertBackgroundDataSdkToUI(sdkData, uiData, csData, 'slideData.background');
        } else {
            StyleConvert.convertBackgroundDataSdkToUI(sdkData, uiData, csData, 'props.background');
        }

        // slide background
        StyleConvert.convertSlideBackgroundDataSdkToUi(sdkData, uiData, csData);

        // border
        StyleConvert.convertBorderDataSdkToUi(sdkData, uiData, csData);

        // effect
        StyleConvert.convertEffectDataSdkToUi(sdkData, uiData, csData);
    }

    /**
     *
     * @param uiData        需要转换的UI数据，UIModel的子集
     * @param sdkData       转换到的目标数据
     */
    public static convertDataUiToSdk(uiData, sdkData) {
        // background
        StyleConvert.convertBackgroundDataUiToSdk(uiData, sdkData);

        // border
        StyleConvert.convertBorderDataUiToSdk(uiData, sdkData);

        // effect
        StyleConvert.convertEffectDataUiToSdk(uiData, sdkData);
    }

    // =============================================

    public static convertBackgroundDataSdkToUI(sdkData, uiData, csData, path = 'props.background') {
        if (ChangesetHelper.dataHasChangeAtPath(csData, path)) {
            if (_has(sdkData, path)) {
                if (!_has(uiData, 'props.style')) _set(uiData, 'props.style', {});
                if (_has(sdkData, `${path}.grpFill`)
                    && _get(sdkData, path).grpFill === 1) {
                    enumerateGroup(uiData, (groupModel) => {
                        if (_get(groupModel, 'props.style.fillBackground.grpFill') !== 1) {
                            sdkToUI.copyBackground(groupModel.props.style, uiData.props.style);
                            return true;
                        }
                        return false;
                    });
                } else {
                    sdkToUI.addBackground(_get(sdkData, path), uiData.props.style);
                }
            } else {
                _set(uiData, 'props.style.fillBackground', null);
            }
        }
    }

    private static convertSlideBackgroundDataSdkToUi(sdkData, uiData, csData) {
        if (ChangesetHelper.dataHasChangeAtPath(csData, 'slideData.background')) {
            if (!_has(uiData, 'props.style')) _set(uiData, 'props.style', {});
            if (_has(sdkData, 'slideData.background')) {
                sdkToUI.addBackground(sdkData.slideData.background, uiData.props.style);
            }

            if (!_has(sdkData, 'props.background') && !_has(sdkData, 'slideData.background')) {  // no bg
                _set(uiData.props.style, 'fillBackground', null);
            }
        }
    }

    private static convertBorderDataSdkToUi(sdkData, uiData, csData) {
        if (ChangesetHelper.dataHasChangeAtPath(csData, 'props.outline')) {
            if (!_has(uiData, 'props.style')) _set(uiData, 'props.style', {});
            if (_has(sdkData, 'props.outline')) {
                sdkToUI.addBorder(sdkData.props.outline, uiData.props.style);
            } else {  // no border
                _set(uiData.props.style, 'border', null);
            }
        }
    }

    private static convertEffectDataSdkToUi(sdkData, uiData, csData) {
        if (ChangesetHelper.dataHasChangeAtPath(csData, 'props.effectList')) {
            if (!_has(uiData, 'props.style')) _set(uiData, 'props.style', {});
            if (_has(sdkData, 'props.effectList')) {
                sdkToUI.addEffect(sdkData.props.effectList, uiData.props.style);
            } else {
                _set(uiData.props.style, 'effect', null);
            }
            /** 拷贝父元素的effect到子元素上，如果子元素已经有相同属性的effect，则忽略 */
            enumerateGroup(uiData, (groupModel) => {
                if (_has(groupModel, 'props.style.effect')) {
                    sdkToUI.copyEffect(groupModel.props.style.effect, uiData.props.style);
                    return true;
                }
                return false;
            });
        }
    }


    // =============================================

    private static convertBackgroundDataUiToSdk(uiData, sdkData) {
        // background
        if (_has(uiData, 'props.style.fillBackground')) {
            if (uiData.type === 'Slide') {  // slide数据格式和shape不一样
                if (uiData.props.style.fillBackground) {
                    if (!_has(sdkData, 'slideData.background')) {
                        _set(sdkData, 'slideData.background', {});
                    }
                    uiToSdk.addBackground(uiData.props.style, sdkData.slideData.background);
                } else {
                    _set(sdkData, 'slideData.background', null);
                }
            } else {
                if (!_has(sdkData, 'props.background')) {
                    _set(sdkData, 'props.background', {});
                }
                uiToSdk.addBackground(uiData.props.style, sdkData.props.background);
            }
        }
    }

    private static convertBorderDataUiToSdk(uiData, sdkData) {
        // border
        if (_has(uiData, 'props.style.border')) {
            if (uiData.props.style.border) {
                if (!_has(sdkData, 'props.outline')) {
                    _set(sdkData, 'props.outline', {});
                }
                uiToSdk.addBorder(uiData.props.style, sdkData.props.outline);
            } else {
                _set(sdkData, 'props.outline', null);
            }
        }
    }

    private static convertEffectDataUiToSdk(uiData, sdkData) {
        if (_has(uiData, 'props.style.effect')) {
            if (uiData.props.style.effect) {
                if (!_has(sdkData, 'props.effectList')) {
                    _set(sdkData, 'props.effectList', {});
                }
                uiToSdk.addEffect(uiData.props.style, sdkData.props.effectList);
            } else {
                _set(sdkData, 'props.effectList', null);
            }
        }
    }
}
